const sectionBannerB1Css = `
[data-type='section-banner-b1'] .wrapper-container {
  position: relative;
  color: var(--color-text-content, #ffffff);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

[data-type='section-banner-b1'] .wrapper-container[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-banner-b1'] .wrapper-container[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-banner-b1'] .background-section {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

[data-type='section-banner-b1'] .background-section-mobile {
  display: none;
}

[data-type='section-banner-b1'] .overlay-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

[data-type='section-banner-b1'] .wrap-content {
  position: relative;
  z-index: 10;
  max-width: 500px;
  margin: 0 auto;
}

[data-type='section-banner-b1'] .wrap-content[data-align='left'] {
  margin-left: 0;
}

[data-type='section-banner-b1'] .wrap-content[data-align='right'] {
  margin-right: 0;
}

[data-type='section-banner-b1'] .wrap-text-decor {
  margin-bottom: 25px;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating {
  display: none;
  margin-bottom: 15px;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating[data-show-rating='true'] {
  display: block;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-rated {
  display: flex;
  gap: 10px;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars {
  display: flex;
  gap: 4px;
  color: #c4c4c4;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars svg {
  fill: #c4c4c4;
}

[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars[data-value='1'] svg:nth-child(-n + 1),
[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars[data-value='2'] svg:nth-child(-n + 2),
[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars[data-value='3'] svg:nth-child(-n + 3),
[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars[data-value='4'] svg:nth-child(-n + 4),
[data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-stars[data-value='5'] svg:nth-child(-n + 5) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-banner-b1'] .wrap-text-decor .tag {
  display: none;
}

[data-type='section-banner-b1'] .wrap-text-decor .tag[data-show-tag='true'] {
  display: block;
  width: fit-content;
  padding: 10px 12px;
  font-size: 18px;
  font-weight: bold !important;
  border-radius: 8px;
  font-style: italic;
}

[data-type='section-banner-b1'] .title {
  padding-bottom: 16px;
  font-weight: bold !important;
}

[data-type='section-banner-b1'] .title h1,
[data-type='section-banner-b1'] .title h2,
[data-type='section-banner-b1'] .title h3 {
  font-size: 48px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-banner-b1'] .content {
  font-size: 20px;
  margin-bottom: 16px;
}

[data-type='section-banner-b1'] .wrap-btn {
  display: none;
}

[data-type='section-banner-b1'] .wrap-btn[data-show-btn='true'] {
  display: block;
}

[data-type='section-banner-b1'] .wrap-btn a {
  display: block;
  padding: 16px 32px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: bold !important;
  text-align: center;
  font-size: 16px;
}

[data-type='section-banner-b1'] .wrap-btn .sub-button {
  margin-top: 12px;
  text-align: center;
}

[data-type='section-banner-b1'] .features {
  display: none;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 18px;
}

[data-type='section-banner-b1'] .features[data-show-features='true'] {
  display: flex;
}

[data-type='section-banner-b1'] .features > div {
  width: calc((100% - (16px * (var(--col-per-view, 3) - 1))) / var(--col-per-view, 3));
  display: flex;
  align-items: center;
  gap: 5px;
}

[data-type='section-banner-b1'] .features > div .icon {
  display: block;
  width: 30px;
  height: auto;
}

[data-type='section-banner-b1'] .features > div .text-feature {
  font-size: 16px;
}

[data-type='section-banner-b1'] .features > div .text-feature p {
  margin-bottom: 0;
}

@container (max-width: 768px) {
  [data-type='section-banner-b1'] .wrapper-container[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-banner-b1'] .wrapper-container[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-banner-b1'] .background-section {
    display: none;
  }

  [data-type='section-banner-b1'] .background-section-mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  [data-type='section-banner-b1'] .wrap-content {
    max-width: 100%;
  }

  [data-type='section-banner-b1'] .wrap-text-decor {
    text-align: center;
  }

  [data-type='section-banner-b1'] .wrap-text-decor .block-rating .wrap-rated {
    justify-content: center;
  }

  [data-type='section-banner-b1'] .wrap-text-decor .tag[data-show-tag='true'] {
    font-size: 16px;
    width: 100%;
  }

  [data-type='section-banner-b1'] .title {
    text-align: center;
  }

  [data-type='section-banner-b1'] .title h1,
  [data-type='section-banner-b1'] .title h2,
  [data-type='section-banner-b1'] .title h3 {
    font-size: 27px;
  }

  [data-type='section-banner-b1'] .content {
    font-size: 16px;
    text-align: center;
  }

  [data-type='section-banner-b1'] .features {
    margin-top: 200px;
  }

  [data-type='section-banner-b1'] .features > div {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  [data-type='section-banner-b1'] .features > div .text-feature {
    font-size: 13px;
    text-align: center;
  }
}
`;
export default sectionBannerB1Css;
